function attachSwiperArrowHandler(swiper) {
  if (swiper && swiper.el) {  //check to make sure swiper exists in DOM, swiper is hidden on desktop
    const swiperSlides = swiper.el.querySelectorAll(".swiper-slide");
    swiper.el.addEventListener("keydown", (e) => handleSwiperArrowKeyPress(e, swiper, swiperSlides));
  }
}

function handleSwiperArrowKeyPress(event, swiper, slides) {
  if (notAnArrowKey()) return;
  else focusOnNextSlide();

  function notAnArrowKey() {
    return !(event.key === "ArrowLeft" || event.key === "ArrowRight");
  }

  function focusOnNextSlide() {
    const nextSlide = getNextSlide();
    if (nextSlide) {
      const focusElement = getFirstFocusableElementFrom(nextSlide);
      focusElement.focus();
      focusElement.dispatchEvent(new FocusEvent('focus', {bubbles: true}));
    } else {
      return;
    }
  }

  function getNextSlide() {
    const activeSlide = event.target.closest(".swiper-slide");
    if (event.key === "ArrowLeft") {
      return activeSlide.previousElementSibling;
    } else if (event.key === "ArrowRight") {
      return activeSlide.nextElementSibling;
    }
  }

  function getFirstFocusableElementFrom(nextSlide) {
    if (nextSlide.tabIndex > -1) return nextSlide;
    return Array.from(nextSlide.querySelectorAll('*')).filter((child) => child.tabIndex > -1)[0];
  }

}
